<template>
  <div class="Redpacket">
    <Help v-if="showHelp" @close="closeHelp" :hasPhone="hasPhone" @isHelp="helpTrue"></Help>
    <ShareGuide v-show="showShareGuide" @click.native="closeShareGuide"></ShareGuide>

    <template v-if="hasRedpacket && inApp">
      <div class="title opened"></div>
      <div class="tips opened">{{homeTips}}</div>
      <div class="redpacket opened">
        <div class="redpacket-state">{{redpacketState}}</div>
        <div class="redpacket-money">{{random_price}} 元</div>
        <div class="redpacket-icon"></div>
        <div class="redpacket-text" v-if="showRedpacketText" v-html="redpacketText"></div>

        <a v-if="!isActivate" href="#" @click="activateRedpacket">
          <div class="redpacket-btn opened">立即激活</div>
        </a>
        <a v-else-if="isFinish" href="#" @click="checkRedpacket">
          <div class="redpacket-btn opened">查看红包</div>
        </a>
        <div class="redpacket-btn opened" v-else @click="share">邀请好友拆红包</div>

        <div class="redpacket-tips" v-if="showRedpacketTips">
          <count-down v-if="showCountDown"></count-down>
          <div v-else>今日24点前全部拆开就能获得</div>
        </div>
      </div>
    </template>
    <template v-else-if="inShare">
      <div class="title opened"></div>
      <div class="tips opened">{{homeTips}}</div>
      <div class="redpacket opened">
        <div class="redpacket-state">{{redpacketState}}</div>
        <div class="redpacket-money">{{random_price}} 元</div>
        <div
          class="redpacket-icon"
          :class="{isHelp: isHelp || isOwn || !isValid || isFinish, notHelp: !isOwn && !isHelp && isValid && !isFinish}"
          @click="help"
        ></div>
        <div
          class="redpacket-text"
          :class="{isHelp}"
          v-if="showRedpacketText"
          v-html="redpacketText"
        ></div>
        <div class="redpacket-text isOwn" v-if="isOwn && isFinish">去工银e生活</div>

        <div class="redpacket-btn opened" v-if="isOwn && !isFinish && isValid" @click="inviteFriends">邀请好友帮拆</div>
        <a
          class="redpacket-btn opened"
          v-else-if="(isOwn && isFinish) || !isValid"
          @click="checkMyPack"
          href="#"
        >查看我的红包</a>
        <a class="redpacket-btn opened" v-else @click="join" href="#">我也要参与</a>

        <div class="redpacket-tips" v-if="showRedpacketTips">
          <count-down v-if="showCountDown"></count-down>
          <div v-else>{{redpacketTips}}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="title"></div>
      <div class="tips">您今天有一个开年红包未获取</div>
      <div class="redpacket">
        <div class="redpacket-btn" @click="getRedpacket">获取红包</div>
      </div>
    </template>
  </div>
</template>

<script>
import Help from '@/components/Help.vue';
import ShareGuide from '@/components/ShareGuide.vue';
import CountDown from '@/components/CountDown.vue';
import { mapGetters } from 'vuex';
import { getAppShareUrl } from '@/utils';

export default {
  name: 'redpacket',
  components: {
    Help,
    ShareGuide,
    CountDown
  },
  props: {
    isOwn: Boolean,
    inShare: Boolean,
    inApp: Boolean,
    isActivate: Boolean,
    isFinish: Boolean,
    hasRedpacket: Boolean,
    isHelp: Boolean,
    isValid: Boolean,
    random_price: Number
  },
  data() {
    return {
      showHelp: false,
      showRedpacketTips: true,
      showRedpacketText: true,
      showShareGuide: false,
      showCountDown: false,

      homeTips: '恭喜您获得一个红包',
      redpacketState: '已拆开',
      redpacketText: '全部拆开需要5人助力',
      redpacketTips: '红包将于今日24点过期',
      appUrl:
        'https://a.app.qq.com/o/simple.jsp?pkgname=com.icbc.elife&android_schema=com.icbc.elife%3A%2F%2Felife%2Floading%3FactID%3DHD0460190111252&ios_schema=com.icbc.elife%3A%2F%2Felife%3FactID%3DHD0460190111252'
    };
  },
  computed: {
    ...mapGetters([
      'rp_id',
      'hasPhone',
      'hasHelpRedpacket',
      'name',
      'help_users'
    ]),
    helpUsersNum() {
      return this.help_users.length;
    }
  },
  mounted() {
    if (this.inApp) {
      console.log('inapp');
      this.redpacketState = '已拆开';
      this.showCountDown = true;
      this.redpacketText = '已拆开 ' + this.helpUsersNum + '/5';
      if (this.isActivate && this.isFinish) {
        console.log('rp is finish');
        this.showRedpacketTips = false;
        this.showRedpacketText = false;
        this.redpacketState = this.name;
        this.homeTips = '今日红包已拆开，记得明天再来';
      } else if (!this.isActivate && this.hasRedpacket) {
        console.log('rp not activate');
        this.showRedpacketTips = false;
        this.redpacketText = '完成游戏激活红包<br/>最高得2019元开年大礼';
        this.redpacketState = '助力红包';
        this.homeTips = '你有一个助力红包';
      }
    }
    if (this.inShare) {
      console.log('inshare');
      if (this.isOwn) {
        console.log('is own');
        this.redpacketState = '已拆开';
        this.homeTips = '恭喜您获得一个红包';
        this.showRedpacketTips = false;
        if (!this.isValid) {
          this.redpacketState = '已拆完';
          this.redpacketText = '来迟一步<br/> 这个红包不能拆啦';
        } else if (this.isFinish) {
          this.redpacketState = '已拆完';
          this.redpacketText = '您的红包已经全部拆开啦';
        } else {
          this.redpacketText = '已拆开 ' + this.helpUsersNum + '/5';
          this.showRedpacketTips = true;
          this.showCountDown = true;
        }
      } else {
        this.homeTips = '好友向您发来了拆红包求助';
        this.showRedpacketTips = false;
        this.redpacketState = '已拆开';
        this.redpacketText = '活动新户帮拆也能拿红包';
        if (this.isHelp) {
          this.redpacketState = '已拆开';
          this.redpacketText = this.hasHelpRedpacket
            ? '您有个<span>18.22</span>元的红包待激活快前往工银e生活激活吧'
            : '您已成功帮TA拆了红包';
        }
        if (this.isFinish) {
          this.redpacketState = '已拆完';
          this.redpacketText = 'TA的红包已经全部拆完啦';
        }
        if (!this.isValid) {
          this.redpacketState = '已拆完';
          this.redpacketText = '来迟一步<br/> 这个红包不能拆啦';
        }
      }
    }
  },
  methods: {
    checkMyPack(e) {
      e.preventDefault();
      fiboSDK.btnClick('wx-checkMyRp-btn', 'wx查看我的红包');
      setTimeout(() => {
        window.location.href = this.appUrl;
      }, 200);
    },

    join(e) {
      e.preventDefault();
      fiboSDK.btnClick('wx-join-btn', 'wx我也要参与');
      setTimeout(() => {
        window.location.href = this.appUrl;
      }, 200);
    },

    closeHelp() {
      this.showHelp = false;
      this.$emit('close');
    },
    help() {
      if (!this.isHelp && !this.isOwn && this.isValid && !this.isFinish) {
        this.showHelp = true;
      }
      fiboSDK.btnClick('wx-open-btn', 'wx拆');
    },
    helpTrue() {
      this.$emit('isHelp');
    },
    inviteFriends() {
      this.showShareGuide = true;
      fiboSDK.btnClick('wx-inviteFriend-btn', 'wx邀请好友帮拆');
    },
    closeShareGuide() {
      this.showShareGuide = false;
    },
    getRedpacket(e) {
      e.preventDefault();
      this.$router.replace('/game');
      fiboSDK.btnClick('app-get-rp-btn', '获取红包');
    },
    share() {
      var pngUrl =
        'https://v.icbc.com.cn/userfiles/Resources/WAP/eshapp/shiyi/logo.png';
      var shareUrl = fiboSDK.dealUrl(getAppShareUrl(this.rp_id));
      var title = '新春e起拆红包';
      var content = '你来拆，我来拆，齐齐来夺2019元开年大礼';
      var shareInfo = {
        PNGUrl: pngUrl,
        ShareUrl: shareUrl,
        Title: title,
        Content: content
      };
      shareInfo = JSON.stringify(shareInfo);
      window.hybrid_app.share(shareInfo);
      fiboSDK.btnClick('app-inviteFriend-btn', '邀请好友拆红包');
    },
    activateRedpacket(e) {
      e.preventDefault();
      this.$router.replace('/game');
      fiboSDK.btnClick('app-activate-btn', '立即激活');
    },
    checkRedpacket(e) {
      e.preventDefault();
      this.$router.replace('/my');
      fiboSDK.btnClick('app-checkRp-btn', '查看红包');
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/scss/index.scss';

@keyframes fillOut {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.Redpacket {
  .title {
    @include set-image('../assets/images/home-title.png');
    @include set-size(677, 480);
    @include set-lt(35, 81);
    &.opened {
      @include set-image('../assets/images/home-title-opened.png');
      @include set-size(620, 439);
      @include set-lt(65, 70);
    }
  }
  .tips {
    @include set-image('../assets/images/home-tips.png');
    @include set-size(368, 68);
    @include set-lt(192, 444);
    @include set-property(font-size, 22);
    @include set-property(line-height, 47);
    color: #310303;
    &.opened {
      @include set-image('../assets/images/home-tips-opened.png');
      @include set-size(354, 37);
      @include set-property(font-size, 22);
      @include set-property(line-height, 37);
      left: 0;
      right: 0;
      @include set-property(top, 400);
      margin: auto;
      color: #ffffff;
    }
  }
  .redpacket {
    @include set-image('../assets/images/home-redpacket.png');
    @include set-size(385, 514);
    @include set-lt(184, 480);
    z-index: 11;
    &.opened {
      @include set-image('../assets/images/home-redpacket-opened.png');
      @include set-size(388, 577);
      @include set-lt(180, 422);
    }
    &-icon {
      @include set-image('../assets/images/home-icon-index.png');
      @include set-size(115, 109);
      @include set-lt(137, 186);
      z-index: 10;
      &.notHelp {
        @include set-image('../assets/images/home-icon-rmb.png');
        animation: fillOut 1s linear infinite;
      }
      &.isHelp {
        @include set-image('../assets/images/home-icon-chai.png');
      }
    }
    &-state {
      @include set-size(390, 0);
      @include set-property(font-size, 34);
      @include set-lt(0, 56);
      text-align: center;
      color: #800118;
    }
    &-money {
      @include set-size(385, 0);
      @include set-property(font-size, 44.5);
      @include set-lt(0, 110);
      text-align: center;
      font-weight: 600;
      color: #800118;
    }
    &-text {
      width: 100%;
      @include set-property(font-size, 24);
      @include set-property(line-height, 40);
      @include set-lt(0, 300);
      text-align: center;
      white-space: nowrap;
      color: #fbd97c;
      &.isHelp {
        @include set-property(line-height, 40);
        color: #ffffff;
        span {
          @include set-property(font-size, 30);
          color: #fbd97c;
        }
      }
      &.isOwn {
        @include set-property(font-size, 22);
        right: 0;
        left: 0;
        margin: auto;
        @include set-property(top, 380);
        color: #fbd97c;
      }
    }
    &-tips {
      @include set-size(340, 0);
      @include set-property(font-size, 22);
      @include set-lt(24, 500);
      color: #fbd97c;
    }
    &-btn {
      @include set-image('../assets/images/home-redpacket-btn.png');
      @include set-lt(66, 340);
      @include set-size(258, 60);
      @include set-property(font-size, 30.5);
      @include set-property(line-height, 60);
      color: #81010a;
      font-weight: 600;
      z-index: 10;
      &.opened {
        @include set-lt(66, 430);
      }
    }
  }
}
@media (min-aspect-ratio: 750/1182) {
  .Redpacket {
    .title {
      @include set-size(536, 380);
      @include set-lt(108, 80);
      &.opened {
        @include set-size(510, 360);
        @include set-lt(120, 60);
      }
    }
    .tips {
      @include set-size(318, 34);
      @include set-lt(214, 386);
      color: #310303;
      @include set-property(font-size, 20);
      @include set-property(line-height, 34);
      &.opened {
        @include set-size(300, 37);
        left: 0;
        right: 0;
        margin: auto;
        @include set-property(top, 340);
        @include set-property(font-size, 20);
        @include set-property(line-height, 37);
      }
    }
    .redpacket {
      @include set-size(310, 414);
      @include set-lt(220, 426);
      z-index: 10;
      &.opened {
        @include set-size(340, 520);
        @include set-lt(205, 358);
      }
      &-icon {
        @include set-size(115, 109);
        @include set-lt(116, 160);
      }
      &-state {
        @include set-size(340, 0);
        @include set-property(font-size, 34);
        @include set-lt(0, 56);
      }
      &-money {
        @include set-property(font-size, 44.5);
        @include set-lt(0, 100);
        @include set-size(340, 0);
      }
      &-text {
        right: 0;
        left: 0;
        margin: auto;
        @include set-property(top, 280);
        @include set-property(font-size, 24);
        &.isHelp {
          @include set-property(line-height, 40);
          color: #ffffff;
          span {
            @include set-property(font-size, 30);
            color: #fbd97c;
          }
        }
        &.isOwn {
          right: 0;
          left: 0;
          margin: auto;
          @include set-property(top, 350);
          @include set-property(font-size, 22);
          color: #fbd97c;
        }
      }
      &-tips {
        @include set-size(290, 0);
        @include set-property(font-size, 22);
        @include set-lt(24, 446);
      }
      &-btn {
        @include set-size(236, 50);
        @include set-lt(38, 280);
        @include set-property(font-size, 28);
        @include set-property(line-height, 50);
        &.opened {
          @include set-lt(52, 386);
        }
      }
    }
  }
}
</style>